import { Table } from "antd";
import styled from "styled-components";

export const TableStyled = styled(Table)`
  .ant-table {
    border-radius: 12px !important;
    font-family: manrope !important;
  }

  .ant-table-wrapper {
    border-radius: 0;
  }

  .ant-table-tbody {

    // ROW HIGHLIGHT/ REVIEW STATUS INDICATION IS COMMENTED 
    // .row-pending {
    //   background: linear-gradient(90deg, #f1f6fe 0%, #ffffff 100%) !important;
    //   border-color: #0c53bb;
    //   .ant-table-selection-column {
    //     border-left: 2px solid #0c53bb;
    //   }
    // }

    // .row-rework {
    //   background: linear-gradient(90deg, #fff1ea 0%, #ffffff 100%) !important;
    //   border-color: #cd5f24;
    //   .ant-table-selection-column {
    //     border-left: 2px solid #cd5f24;
    //   }
    // }

    // .row-approved {
    //   background: linear-gradient(90deg, #f3fef8 0%, #ffffff 100%) !important;
    //   border-color: #16b361;
    //   .ant-table-selection-column {
    //     border-left: 2px solid #16b361;
    //   }
    // }

    .row-drag-hover {
      background: #dae6f7;
      transition: background 0.2s;
    }

    /* An unread message thread should look unread, not just say so in the
       Unread column - bold text matches the weight convention this table
       already uses to mark the active tab (see StyledHomeTabs). */
    .row-unread > td {
      font-weight: 700 !important;
      color: #1b2028 !important;
    }

    /* A reviewer who created invoices that never went out. Money the
       ledger says is owed by clients who were never contacted, so the
       row is meant to be spotted from across the room without reading a
       column. Left border rather than a full wash so the text stays
       legible, and the tint survives the hover rule below. */
    .row-invoices-unsent > td {
      background-color: #fdf1f1 !important;
    }
    .row-invoices-unsent > td:first-child {
      box-shadow: inset 3px 0 0 #a61412;
    }

    .ant-table-row {
      .share-icon-column {
        padding-right: 0;
        .share-modal-icon {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }

  .ant-checkbox-indeterminate {
    .ant-checkbox-inner::after {
      display: none !important;
    }
  }
  .item-status-row {
    background-color: #f4f4f6 !important;
  }

  /* Red Checkbox for Selected Rows */
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #0C53BB !important;
    border-color: #0C53BB !important;
  }

  /* Red Border on Hover */
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #0C53BB !important;
  }

  /* Red Indeterminate Checkbox */
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: #0C53BB !important;
  }

  /* Change Hover Color for Selected Rows */
  .ant-table-tbody > tr.ant-table-row-selected:hover > td {
    background-color: #f1f6fe !important;
  }

  /* Change Hover Color for Non-Selected Rows */
  .ant-table-tbody > tr:hover > td {
    background-color: #f1f6fe !important;
  }
  .ant-table-tbody > tr.ant-table-row-selected > td {
    background-color: #f4f4f6 !important;
  }
  .action-column {
    min-width: 100px;
  }
  .ant-table-thead > tr > th {
    background-color: var(--TABLE-HEADER-BG-COLOR) !important;
    font-weight: 600;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0.02em;
    text-transform: capitalize;
    color: #48566B !important;
    font-family: 'Manrope', sans-serif;

    border-bottom: 1px solid var(--TABLE-BORDER-COLOR);
    padding: 1rem 1.125rem;
  }
  .ant-table-tbody > tr > th {
    padding: 1.375rem 1rem;
  }
  .ant-table-tbody > tr > td {
    font-family: 'Manrope', sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 100%;
    color: #48566B;
  }
  .ant-table-tbody {
    cursor: pointer;
    border: 1px solid var(--TABLE-BORDER-COLOR);
    .ant-checkbox-wrapper {
      height: 1rem;
    }
  }
  .ant-table-selection-column {
    padding: 1rem 0.25rem 1rem 1.25rem !important;
  }
`;
